import { Component } from '@angular/core';
import { DevCycleService } from '@services/dev-cycle.service';
import { MatDialogService } from '@services/dialogs.service';
import { getFeatureFlags } from '@app/core/helpers/feature-flags.helper';

@Component({
  selector: 'ew-button-create-mat-menu',
  templateUrl: './button-create-mat-menu.component.html',
  styleUrls: ['./button-create-mat-menu.component.scss'],
  providers: [MatDialogService],
})
export class ButtonCreateMatMenuComponent {
  readonly featureFlags$ = getFeatureFlags(
    {
      name: 'ew-2016-revisit-student-payment',
      defaultValue: false,
    },
    {
      name: 'ew-2729-commission-payment-request',
      defaultValue: false,
    },
  );

  constructor(public readonly MDS: MatDialogService) {}
}
